import type { ProductDto, ProductImageDto } from '@kotipizzagroup/kotipizza-products-api-client';
import { Commerce } from '@kotipizzagroup/kotipizza-shared-types';

export type ProductSizeConfig = {
  sizeId: number;
  minimumPrice: number;
};

export type ProductImagesFormData = {
  [productSizeId: number]: ProductImageDto;
};

export type ProductFormData = ProductDto & {
  productSizesConfig: ProductSizeConfig[];
  productImagesFormData: ProductImagesFormData;
  vatId: number;
};

export type ProductSizeModel = {
  sizeId: number;
  sizeName: string;
  calculatedPrice: number;
  minimumPrice: number;
  price: number | null;
};

export type ProductDetailsViewParams = {
  id?: string;
};

export const backgroundColorProductCategories = [
  Commerce.ProductCategory.DIP,
  Commerce.ProductCategory.DRINK,
  Commerce.ProductCategory.ALCOHOL,
  Commerce.ProductCategory.ICECREAM,
];
